import Image from 'next/image';
import { useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  cvaDelete,
  cvaDeleteIcon,
  cvaDrag,
  cvaDragIcon,
  cvaDragIconWrap,
  cvaDragPlaceholder,
  cvaInput,
  cvaRoot,
  cvaSelectedFiles,
  cvaSelectedFilesButton,
  cvaSelectedFilesButtonIcon,
  cvaSelectedFilesSlide,
  cvaSelectedFilesSlideImage,
  cvaSelectedFilesSlideImageWrap,
  cvaSelectedFilesSlider,
} from './DropzoneFilesStyles';
import IconArrow from '/public/icons/arrow-right.svg';
import IconClose from '/public/icons/close.svg';
import FileIcon from '/public/icons/photo_upload.svg';

interface IDropzoneFilesProps {
  onChange: (files: File[]) => void;
  multiple?: boolean;
  placeholder?: string;
  accept?: any;
}

export const DropzoneFiles = ({ onChange, placeholder, multiple = false, accept }: IDropzoneFilesProps) => {
  const prevBtnRef = useRef<HTMLButtonElement>(null);
  const nextBtnRef = useRef<HTMLButtonElement>(null);

  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const onDrop = (acceptedFiles: File[]) => {
    setSelectedFiles([...selectedFiles, ...acceptedFiles]);
    onChange([...selectedFiles, ...acceptedFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: multiple,
    maxSize: 15242880,
    accept: accept ?? {
      '*/*': [],
    },
  });

  return (
    <div className={cvaRoot()} data-cursor={'-pointer'}>
      <div className={cvaSelectedFiles()}>
        <button
          className={cvaSelectedFilesButton({
            direction: 'prev',
          })}
          ref={prevBtnRef}
        >
          <IconArrow
            className={cvaSelectedFilesButtonIcon({
              direction: 'prev',
            })}
          />
        </button>
        <button
          className={cvaSelectedFilesButton({
            direction: 'next',
          })}
          ref={nextBtnRef}
        >
          <IconArrow
            className={cvaSelectedFilesButtonIcon({
              direction: 'next',
            })}
          />
        </button>
        <Swiper
          modules={[FreeMode, Navigation]}
          threshold={10}
          spaceBetween={12}
          slidesPerView={'auto'}
          freeMode
          className={cvaSelectedFilesSlider()}
          navigation={{
            prevEl: prevBtnRef.current,
            nextEl: nextBtnRef.current,
          }}
          onBeforeInit={(swiper: any) => {
            swiper.params.navigation.prevEl = prevBtnRef.current;
            swiper.params.navigation.nextEl = nextBtnRef.current;
          }}
          watchOverflow
        >
          {selectedFiles?.length
            ? selectedFiles.map((file, index) => (
                <SwiperSlide className={cvaSelectedFilesSlide()} key={index}>
                  <div className={cvaSelectedFilesSlideImageWrap()}>
                    <Image
                      className={cvaSelectedFilesSlideImage()}
                      quality={80}
                      src={URL.createObjectURL(file)}
                      fill
                      alt=""
                    />
                  </div>
                  <div
                    className={cvaDelete()}
                    onClick={() => {
                      setSelectedFiles((prev) => {
                        const newArr = [...prev];
                        newArr.splice(index, 1);

                        onChange(newArr);

                        return newArr;
                      });
                    }}
                  >
                    <IconClose className={cvaDeleteIcon()} />
                  </div>
                </SwiperSlide>
              ))
            : null}
        </Swiper>
      </div>
      <div className={cvaDrag()} {...getRootProps()}>
        <input {...getInputProps()} className={cvaInput()} />
        <div className={cvaDragIconWrap()}>
          <FileIcon className={cvaDragIcon()} />
        </div>
        <div className={cvaDragPlaceholder()}>
          {/* {selectedFiles.length ? selectedFiles[0].name : <div dangerouslySetInnerHTML={{__html: placeholder ?? ''}}></div>} */}
          <div
            dangerouslySetInnerHTML={{
              __html: placeholder ?? '',
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};
